class Validate {
    exists(v){
        return (v !== undefined && v !== null);
        // console.log(v === undefined)
        // console.log(v === null);
    }
}
export default new Validate();